export { default } from './provider';

export * from './hook';

export type {
  IModelProps as CanvasMarkingProps,
  IImperativeRef as CanvasMarkingImperativeRef,
  IPlugins as CanvasMarkingPropsPlugins
} from './types';

export * from '@kcuf/canvas-marking';
